import routerOptions0 from "D:/Project/vue/frontend_new/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.19.23_eslint@8.57.0_less@4.2.0_rollup@4.12.1_sass@1.64.1_stylelint@_ey5qk2pu4dcixfe324qv6lsswe/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}